













import Vue from 'vue'
import Component from 'vue-class-component'

import { SETTINGS_PAGE_INFORMATION } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-2-customer-website-page-information'

@Component({
  components: {}
})
class SettingsHelperComponents2Header extends Vue {
  SETTINGS_PAGE_INFORMATION = SETTINGS_PAGE_INFORMATION
}

export default SettingsHelperComponents2Header
